import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Field, Form, TextArea } from '@/components';

import { FinancialHighlights, Project, TeamAndGovernance } from '@/features/projects/types';

import { nullableStringSetter } from '@/helpers';

export type TeamGovernanceSubmitFields = {
  details: string;
};

export type TeamGovernanceFormFields = {
  details: string;
};

export type TeamGovernanceFormProps = {
  readonly id: string;
  readonly project: Project;
  readonly onSubmit: (data: TeamGovernanceSubmitFields) => void;
};

export function TeamAndGovernanceForm({ id, project, onSubmit }: TeamGovernanceFormProps) {
  const { t } = useTranslation(['projects']);
  const item = project.team_and_governance?.[0] ?? ({} as Partial<TeamAndGovernance>);

  const options = useMemo(
    () => ({
      defaultValues: {
        details: item.details ?? null,
      },
    }),
    [item]
  );

  const onSubmitTeamGovernanceForm = useCallback(
    (data: TeamGovernanceFormFields) => {
      const payload = {
        details: data.details,
      };

      onSubmit(payload);
    },
    [onSubmit]
  );

  return (
    <Form<TeamGovernanceFormFields> id={id} onSubmit={(data) => onSubmitTeamGovernanceForm(data)} options={options}>
      {({ formState, register }) => (
        <div className="space-y-6">
          <Field
            id="details"
            label={t('Details')}
            error={formState.errors['details']}
            delay={0.6}
            classes={{ field: 'space-y-1' }}
          >
            <TextArea
              id="details"
              color={formState.errors['details'] ? 'error' : 'primary'}
              registration={register('details', { setValueAs: nullableStringSetter })}
              className="min-h-32"
            />
          </Field>
        </div>
      )}
    </Form>
  );
}
